export default function isReadonlySet<T>(
  value: unknown,
): value is ReadonlySet<T> {
  return value instanceof Set;
}
